import UserOrderItem from './user-order-item.vue';

export default UserOrderItem;